import { Clock } from "lucide-react";

const KEY = "fhp-ust-recent";
export const readRecent = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; } };
export const pushRecent = (f) => {
  const list = [f, ...readRecent().filter((x) => x.facilityId !== f.facilityId)].slice(0, 5);
  try { localStorage.setItem(KEY, JSON.stringify(list)); } catch { /* full */ }
};

export const RecentLookups = ({ onOpen, t }) => {
  const list = readRecent();
  if (!list.length) return null;
  return (
    <div className="card ust-recent" data-testid="ust-recent">
      <div className="label"><Clock size={12} /> {t("Recent lookups")}</div>
      {list.map((f) => (
        <button key={f.facilityId} type="button" className="ust-recent-item" onClick={() => onOpen(f)} data-testid={`ust-recent-${f.facilityId}`}>
          <b>{f.name}</b><span className="card-sub">{f.address}</span>
        </button>
      ))}
    </div>
  );
};
